module.exports = __webpack_public_path__ + "webfonts/398F09_0_0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_0.ttf
// module id = 55
// module chunks = 0